var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-app"},[(_vm.status)?_c('div',{staticClass:"onload-pdf",on:{"click":_vm.onloadPdf}},[_c('div',[_vm._v("点我下载")]),_c('span',[_vm._v("本地下载查看")])]):_c('div',{attrs:{"id":"demo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }